/**
 * Generator function để duyệt qua tất cả leaf nodes trong nested object.
 * Bỏ qua null values và arrays.
 *
 * @generator
 * @param {Object} obj - Object cần duyệt
 * @param {string[]} path - Đường dẫn hiện tại (internal use)
 * @yields {Object} { path: string[], key: string, value: any }
 *   - path: mảng các key từ root đến node
 *   - key: đường dẫn dạng string (ví dụ: 'doors.louver.dulux')
 *   - value: giá trị tại leaf node
 *
 * @example
 * const obj = { a: { b: 10, c: { d: 20 } } };
 * for (const leaf of walkLeaves(obj)) {
 *   console.log(leaf);
 *   // { path: ['a', 'b'], key: 'a.b', value: 10 }
 *   // { path: ['a', 'c', 'd'], key: 'a.c.d', value: 20 }
 * }
 *
 * Generator Function - function* và yield
 * Dấu * là gì?
 * function* không phải function bình thường. Nó là generator function - một function đặc biệt có thể dừng giữa chừng và tiếp tục sau.
 * yield làm gì?
 * yield là từ khóa để tạm dừng function và trả về một giá trị. Khi gọi lại, nó tiếp tục từ chỗ dừng.
 */
export function* walkLeaves(obj, path = []) {
  for (const [key, value] of Object.entries(obj)) {
    const currentPath = [...path, key];

    if (value === null) continue;

    if (
      typeof value === 'object' &&
      !Array.isArray(value) &&
      Object.keys(value).length !== 0
    ) {
      yield* walkLeaves(value, currentPath);
    } else {
      yield { path: currentPath, key: currentPath.join('.'), value };
    }
  }
}
